import { render, staticRenderFns } from "./SimpleSwiper.vue?vue&type=template&id=8748ff9c&scoped=true"
import script from "./SimpleSwiper.vue?vue&type=script&lang=js"
export * from "./SimpleSwiper.vue?vue&type=script&lang=js"
import style0 from "./SimpleSwiper.vue?vue&type=style&index=0&id=8748ff9c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8748ff9c",
  null
  
)

export default component.exports